<template>
    <h1 class="text-3xl drop-shadow-lg"><slot/></h1>
    <hr class="w-1/2 mt-2 mb-8 h-0.5 bg-gradient-to-r from-amber-800 border-0">
</template>
